var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('control-container',{attrs:{"customClass":"navbar-links flex flex-initial w-auto h-auto"}},_vm._l((_vm.links),function(link){return _c('control-link',{key:link.id,attrs:{"level":_vm.level,"color":_vm.color,"link":link}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }